const { useState, useEffect } = require('react');

export function useLocalStorageState(initialState, key) {
	const [value, setValue] = useState(function () {
		const storeValued = localStorage.getItem(key);
		return storeValued ? JSON.parse(storeValued) : initialState;
	});
	// For Local Storage
	useEffect(() => {
		localStorage.setItem(key, JSON.stringify(value));
	}, [value, key]);

	return [value, setValue];
}
